/**
 * patrol-apprehension-edit.js
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import { EditorIconSection } from 'components/icon-section/icon-section';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import HiddenInput from 'components/form-inputs/hidden-input';
import CheckboxList from 'components/form-inputs/checkbox-list';
import PatrolArrestsBitesEdit from '../../helpers/patrol-arrests-bites-edit';


export default function PatrolNonSearchEdit(props) {
  const {
    drawerState,
    edit,
    patrolIndex,
    isAdd
  } = props;
  const { t } = useTranslation(edit.translation);


  return (
    <>
      {/* patrol-type id */}
      <HiddenInput 
        name={`patrol.patrolTypes[${patrolIndex}].id`} 
        defaultValue={isAdd ? '' : undefined}
      />

      {/* type */}
      <HiddenInput 
        name={`patrol.patrolTypes[${patrolIndex}].type`}
        defaultValue={isAdd ? Types.Patrol.NONSEARCH : undefined}
      />

      {/* order */}
      <HiddenInput 
        name={`patrol.patrolTypes[${patrolIndex}].order`} 
        defaultValue={isAdd ? patrolIndex + 1 : undefined}
      />

      {/* apprehension id */}
      <HiddenInput 
        name={`patrol.patrolTypes[${patrolIndex}].nonSearch.id`} 
        defaultValue={isAdd ? '' : undefined}
      />


      <EditorIconSection
        iconName='patrol-non-search'
        iconMarginTop={6}
        helpProps={{
          translation: edit.translation,
          section: 'nonSearch'
        }}
      >
        {/* warrant types */}
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('nonSearch.warrant.helpTitle')}
          text={t('nonSearch.warrant.helpInfo')}
        >
          {focusHandlers =>
            <CheckboxList
              name={`patrol.patrolTypes[${patrolIndex}].nonSearch.types`}
              label={t('nonSearch.warrant.label')}
              dataTestId='non-search-warrant-types'
              options={edit.options.warrantTypes}
              customOther
              focusHandlers={focusHandlers}
            />}
        </HelpTextItem>
      </EditorIconSection>
      

      {/* arrests / bites */}
      <PatrolArrestsBitesEdit {...props} />
    </>
  );
}